module.exports = __webpack_public_path__ + "static/media/qlocx.362db674.png";